(function () {
    'use strict';

    var app = angular.module('skillsApp', [
        'ui.bootstrap',
        'pascalprecht.translate',
        'ui.grid',
        'ui.grid.autoResize',
        'ngSanitize',
        'ui.select',
        'cgBusy',
        'ui.router',
        'ncy-angular-breadcrumb',
        'clickAndWait',
        'nya.bootstrap.select'
    ]);
    
    app.config(['$compileProvider', function ($compileProvider) {
        $compileProvider.debugInfoEnabled(false);
    }]);

    app.config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('httpConflictHandler');
        }
    ]);

    // defer intercept urlRouterProvider
    app.config(function ($urlRouterProvider) {
        $urlRouterProvider.deferIntercept();
    });
  
    // configure stateProvider
    app.config(function ($stateProvider, $urlRouterProvider, $locationProvider, $transitionsProvider, $rootScopeProvider, appStates) {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise("/skills/employee");

        for (var i = 0; i < appStates.states.length; i++) {
            $stateProvider.state(appStates.states[i]);
        }
    });

    // set hashPrefix
    app.config(function ($locationProvider) {
        $locationProvider.hashPrefix('!');
    });
    
    // load portalSettings and continue routing
    app.run(function ($window, $transitions, $urlRouter, $timeout, config, logger, dataService, tokenService) {

        logger.log('href:', $window.location.href);

        $transitions.onStart({}, function (trans) {
            var next = trans.to();

            if (next.name === 'oidc-callback') return;
            if (next.name === 'oidc-silent-callback') return;
            if (next.name === 'error') return;

            if (next.name != 'maintenance' && config.settings.maintenance) {
                var redirectToMaintenance = false;
                switch (config.settings.maintenance.status) {
                    case 'off':
                        break;
                    case 'on':
                        redirectToMaintenance = true;
                        break;
                    case 'adminOnly':
                        redirectToMaintenance = !config.settings.user.isAdmin;
                        break;
                }

                if (redirectToMaintenance) return trans.router.stateService.target('maintenance');
            }

            if (config.settings.user == null) config.settings.user = {};
            if (config.settings.user.isAdmin) return;
            
            var authorizedRoles = (next.data && next.data.authorizedRoles) ? next.data.authorizedRoles : null;
            if (!authorizedRoles) return;
            
            if (!angular.isArray(authorizedRoles)) {
                authorizedRoles = [authorizedRoles];
            }

            for (var i = 0; i < authorizedRoles.length; i++) {
                var role = authorizedRoles[i];
                switch (role) {
                    case 'admin':
                        if (config.settings.user.isAdmin) return;
                        break;
                    case 'manager':
                        if (config.settings.user.isManager) return;
                        break;
                    case 'assessor':
                        if (config.settings.user.isAssessor) return;
                        break;
                    case 'skills-report-viewer':
                        if (config.settings.user.isReportViewer && config.settings.reportViewerSettings.showSkillsReport) return;
                        break;
                    case 'departments-report-viewer':
                        if (config.settings.user.isReportViewer && config.settings.reportViewerSettings.showDepartmentsReport) return;
                        break;
                    case 'examiner':
                        if (config.settings.user.isExaminer) return;
                        break;
                }
            }

            logger.error('not_authorized');
            return trans.router.stateService.target('app-main.employee');
        });
        
        if ($window.location.pathname.indexOf('/skills/oidc-callback') != -1) {
            logger.log('continue to oidc-callback');
            return tokenService.oidcCallback();
        }

        if ($window.location.pathname.indexOf('/skills/oidc-silent-callback') != -1) {
            logger.log('continue to oidc-silent-callback');
            return tokenService.oidcCallbackSilent();
        }
        
        return dataService.getSettings()
            .then(settings => {
                    logger.log('get settings success');
                    config.settings = settings.data;
                }, response => {
                    logger.log('get settings failed');
                    if (response) {
                        config.settings = { maintenance: { status: 'on', message: 'maintenance_failed_to_initialize_skills' }, user: {} };
                    }
                })
            .then(() => {
                logger.log('continue routing');

                return $timeout(function () {
                    $urlRouter.sync();
                    $urlRouter.listen();
                }, 0);
            });
    });

    // translations
    app.config(function ($sceDelegateProvider, $translateProvider, language, nyaBsConfigProvider) {
        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            'http://skills.dev-026.competence.biz/**'
        ]);
        
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.useLoader('translationsLoader');
        
        $translateProvider
            .registerAvailableLanguageKeys(['en', 'nl'], {
                'en*': 'en',
                'nl*': 'nl',
                '*': 'en'
            })
            .fallbackLanguage('en')
            .useLoaderCache(true);
        
        if (language && typeof language === 'string' && language.length > 0) {
            $translateProvider.use(language);
        } else {
            $translateProvider.determinePreferredLanguage();
        }

        language = $translateProvider.preferredLanguage();

        var cfg = {
            defaultNoneSelection: ' ',
            noSearchResult: ' '
        };

        nyaBsConfigProvider.setLocalizedText('en-us', cfg);
        nyaBsConfigProvider.setLocalizedText('nl-nl', cfg);
        nyaBsConfigProvider.useLocale(language);
    });

})();